import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { scrollToComprar } from '../utils';
export function WhatYouLearn() {
  const items = ['Cómo hacer la transición de alimento balanceado a comida natural sin causarle diarrea ni malestar.', 'Las proporciones exactas de carne, huesos carnosos, vísceras y vegetales según el peso y edad de tu perro.', 'Más de 50 recetas caseras fáciles, rápidas y económicas que podés preparar con ingredientes del súper.', 'La lista definitiva de alimentos prohibidos y tóxicos que nunca debés darle.', 'Cómo preparar suplementos naturales en casa (caldo de huesos, kéfir, pasta dorada).', 'Estrategias para ahorrar dinero y tiempo preparando viandas mensuales.'];
  return <section className="py-12 md:py-16 px-4 bg-white" data-id="element-229">
      <div className="max-w-4xl mx-auto" data-id="element-230">
        <div className="text-center mb-8 md:mb-10" data-id="element-231">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-232">
            ¿Qué vas a aprender en este libro?
          </h2>
          <p className="text-lg text-brown-light" data-id="element-233">
            Una guía paso a paso, sin lenguaje técnico, diseñada para que
            empieces hoy mismo.
          </p>
        </div>

        <div className="bg-cream p-6 md:p-8 rounded-3xl border border-cream-dark shadow-sm" data-id="element-234">
          <ul className="space-y-4" data-id="element-235">
            {items.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex gap-4 items-start" data-id="element-236">
                <div className="flex-shrink-0 mt-1" data-id="element-237">
                  <CheckCircle2 className="text-primary" size={24} data-id="element-238" />
                </div>
                <p className="text-brown font-medium text-lg leading-relaxed" data-id="element-239">
                  {item}
                </p>
              </motion.li>)}
          </ul>

          <div className="mt-8 text-center" data-id="element-240">
            <button onClick={scrollToComprar} className="bg-primary hover:bg-primary-light text-white font-bold text-lg py-4 px-8 rounded-xl shadow-lg transform transition hover:-translate-y-1 w-full md:w-auto inline-flex items-center justify-center gap-2" data-id="element-241">
              QUIERO APRENDER A ALIMENTARLO BIEN
            </button>
          </div>
        </div>
      </div>
    </section>;
}